import React from 'react';
import { Link } from 'react-router-dom';

import Service1 from '../../assets/images/services/sv-1.jpg';
import Service2 from '../../assets/images/services/sv-2.jpg';
import Service3 from '../../assets/images/services/sv-3.jpg';
import Service4 from '../../assets/images/services/sv-4.jpg';
import Service5 from '../../assets/images/services/sv-5.jpg';
import Service6 from '../../assets/images/services/sv-6.jpg';

function Servicepage() {
    const services = [
    {
        image: Service1,
        category: "Consulting",
        icon: "consulting",
        title: "HR Consulting",
        link: "/hr-consulting",
        text: "Strategic HR solutions including workforce planning, employee engagement, and organizational development."
    },
    {
        image: Service2,
        category: "Technology",
        icon: "controller",
        title: "IT Recruitment",
        link: "/it-recruitment",
        text: "Specialized hiring solutions for software development, cloud computing, cybersecurity, and AI professionals."
    },
    {
        image: Service3,
        category: "Digital Marketing ",
        icon: "policy",
        title: "Digital Marketing Training",
        link: "/digital-marketing",
        text: "Comprehensive training programs for digital marketing strategies, social media management, and online advertising."
    },
    {
        image: Service4,
        category: "Recruitment",
        icon: "policy",
        title: "Non-IT Recruitment",
        link: "/non-it-recruitment",
        text: "End-to-end recruitment services across finance, HR, sales, healthcare, operations, and administration."
    },
    {
        image: Service5,
        category: "Leadership",
        icon: "job",
        title: "Executive Search",
        link: "/executive-search",
        text: "Leadership hiring solutions for directors, executives, vice presidents, and C-suite professionals."
    },
    {
        image: Service6,
        category: "Campus",
        icon: "teaching",
        title: "Campus Hiring",
        link: "/campus-hiring",
        text: "Structured campus recruitment programs connecting organizations with talented graduates and fresh professionals."
    },
    {
        image: Service2,
        category: "Training",
        icon: "employment",
        title: "Internship & Training Programs",
        link: "/internship-training",
        text: "Career-focused internships, technical training, mentorship, and employability development programs."
    },
    {
    image: Service1,
    category: "Career",
    icon: "consulting",
    title: "Career Guidance & Placement Assistance",
    link: "/career-guidance",
    text: "Personalized career counseling, resume building, interview preparation, and placement assistance services."
},
{
    image: Service2,
    category: "Digital",
    icon: "controller",
    title: "Digital Hiring Solutions",
    link: "/digital-hiringsolutions",
    text: "Technology-driven recruitment solutions using ATS, AI sourcing, virtual interviews, and recruitment analytics."
}
];

    return (
        <section className="service-one service-one--page">
            <div className="container">
                <div className="row gutter-y-30">
                    {services.map((service, index) => (
                        <div key={index} className="col-md-6 col-lg-4">
                            <div className="service-one-card service-card-two" data-wow-duration="1500ms" data-wow-delay={`${index}ms`}>
                                <div className="service-one-card__image">
                                    <img src={service.image} alt={service.title} />
                                </div>
                                <div className="service-one-card__content">
                                    <div className="service-one-card__icon">
                                        <i className={`icon-${service.icon}`} />
                                        <Link to="/services" className="service-one-card__cat">
                                            {service.category}
                                        </Link>
                                    </div>
                                    <h3 className="service-one-card__title">
                                        <Link to={service.link}>{service.title}</Link>
                                    </h3>
                                    <p className="service-one-card__text">{service.text}</p>
                                </div>
                                <Link to={service.link} className="service-one-card__link">
                                    Read More
                                    <i className="icon-right-arrow" />
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Servicepage;
